<template>
  <Loader
    :value="promises.fetch"
    :message="$t('loading', { resource: $tc('unitCatalog', 1).toLowerCase() }) + '...'"
    class="residential-templates"
  >
    <div class="container view">
      <HeaderComponent :title="$metaInfo.title">
        <template #actions>
          <Actions placement="residentialTemplates" />
          <ButtonComponent
            tag="router-link"
            :to="{ name: 'residential-template-create', query: { returnTo: $route.path } }"
            :label="$t('create')"
            :icon="['fal', 'plus']"
            theme="primary"
          />
        </template>
      </HeaderComponent>
      <div class="residential-templates__content">
        <ResidentialTemplateCard v-for="item in items" :key="item.id" :value="item" />
      </div>
      <EmptyState
        v-if="!items.length && !states.fetch"
        :title="$t('noX', { x: this.$tc('unit', 2).toLowerCase() })"
        :icon="['fal', 'puzzle-piece']"
        action-portal
      />
    </div>
  </Loader>
</template>

<script>
import HeaderComponent from '@/components/Header'
import Actions from '@/components/Actions'
import ResidentialTemplateCard from '@/components/ResidentialTemplate/Card'
import Card from '@/components/Card'
import EmptyState from '@/components/EmptyState'
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('ResidentialTemplate', ['items', 'promises', 'states']),
  },
  methods: {
    ...mapActions('ResidentialTemplate', ['fetch']),
  },
  created() {
    this.fetch()
  },
  metaInfo() {
    return {
      title: this.$tc('unitCatalog', 1),
    }
  },
  components: {
    ResidentialTemplateCard,
    Card,
    HeaderComponent,
    Actions,
    EmptyState,
  },
}
</script>

<style lang="scss">
.residential-templates {
  background-color: $background-grey;

  &__content {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: $form-gap;
  }
}
</style>
